/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "./PlayTypeSelector.module.scss";
import Body from "ui/kit/typography/Body";
import PlayType from "ui/feature/piece-play/common/PlayType";

interface Props {
    playType: PlayType;
    setPlayType: (playType: PlayType) => void;
}

const PlayTypeSelector: React.FC<Props> = ({setPlayType, playType}) => {

    const onChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = e.target;
        setPlayType(value as PlayType);
    }, [setPlayType]);

    return (
        <form className={styles.form}>
            <input onChange={onChange} checked={playType === "left_hand"} name={"play_type"} type="radio"
                   value={"left_hand"}/>
            <label>
                <Body>Left Hand</Body>
            </label>
            <input onChange={onChange} checked={playType === "right_hand"} name={"play_type"} type="radio"
                   value={"right_hand"}/>
            <label>
                <Body>Right Hand</Body>
            </label>
            <input onChange={onChange} checked={playType === "both_hands"} name={"play_type"} type="radio"
                   value={"both_hands"}/>
            <label>
                <Body>Both Hands</Body>
            </label>
        </form>
    )
}

export default PlayTypeSelector
